import { render, staticRenderFns } from "./SalesParametersCalculationModal.vue?vue&type=template&id=087e3166&scoped=true&"
import script from "./SalesParametersCalculationModal.vue?vue&type=script&lang=js&"
export * from "./SalesParametersCalculationModal.vue?vue&type=script&lang=js&"
import style0 from "./SalesParametersCalculationModal.vue?vue&type=style&index=0&id=087e3166&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087e3166",
  null
  
)

export default component.exports